<template>
    <b-button variant="primary" class="emr-sync-button" @click="update">
        {{ $translate(emrType) }}
    </b-button>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import BackendProvider from '../../business/services/BackendProvider'
import UIUtils from '../../business/utils/UIUtils'
import { EMR_TYPES, INSTRUMENT_TYPE } from '../../business/const'

export default {
    name: 'EmrSyncButton',
    computed: {
        ...mapState({
            selectedSlide: state => state.timelapse.selectedSlide,
            selectedPatient: state => state.timelapse.selectedPatient,
            selectedTreatment: state => state.timelapse.selectedTreatment,
            selectedTenant: state => state.common.selectedTenant
        }),
        ...mapGetters({
            getSelectedInstrument: 'timelapse/getSelectedInstrument'
        }),
        instrumentType() {
            return this.selectedSlide.instrumentType
        },
        emrType() {
            const { emrType } = this.selectedTenant

            if (emrType === EMR_TYPES.VREPRO) {
                return `${EMR_TYPES.VREPRO.toLowerCase()}`
            } else if (emrType === EMR_TYPES.MEDITEX) {
                return `${EMR_TYPES.MEDITEX.toLowerCase()}`
            } else if (emrType === EMR_TYPES.IDEAS) {
                return `${EMR_TYPES.IDEAS.toLowerCase()}`
            } else {
                return emrType
            }
        }
    },
    methods: {
        async update() {
            let patientEsId = this.selectedPatient.esId
            if (this.instrumentType === INSTRUMENT_TYPE.VITRO) {
                patientEsId = this.selectedPatient.identifier1
            }
            const payload = {
                patient: {
                    id: this.selectedPatient._id,
                    esId: patientEsId
                },
                tenantId: this.selectedTenant._id,
                instrument: {
                    id: this.getSelectedInstrument._id,
                    esId: this.getSelectedInstrument.esId
                },
                treatment: {
                    id: this.selectedTreatment._id,
                    esId: this.selectedTreatment.slides[0].treatment.esId
                },
                slide: {
                    id: this.selectedSlide._id,
                    esId: this.selectedSlide.esId,
                    wells: [
                        ...this.selectedSlide.wells.filter(well => !!well).map(well => well._id)
                    ]
                }
            }
            try {
                UIUtils.showLoadingMask()
                const body = await BackendProvider.updateEmr(payload)
                // if (this.selectedTenant.emrType === EMR_TYPES.VREPRO) {
                //     body = await BackendProvider.updateVRepro(payload)
                // } else {
                //     body = await BackendProvider.updateEmr(payload)
                // }
                if (body && body.statusCode === 201) {
                    UIUtils.toast(body.message)
                }
            } catch (e) {
                console.warn(e)
                if (e.body && e.body.statusCode === 400) {
                    UIUtils.toast(e.body.message)
                } else {
                    UIUtils.toast(this.$translate('v_repro_sync_error'), 'error')
                }
            } finally {
                UIUtils.hideLoadingMask()
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.emr-sync-button {
    position: fixed;
    z-index: 99;
    bottom: 1rem;
    right: 10rem;
    padding: 0.87rem 2.3rem;
    font-weight: bold !important;
}
</style>
